import {
  CalendarToday,
  Inventory,
  LocalShipping,
  QuestionMark,
  TrendingUp
} from '@mui/icons-material';
import { Box, Grid, Paper, Typography } from '@mui/material';
import React from 'react';
import CompactStatCard from './CompactStatCard';
import SectionHeader from './SectionHeader';

export default function YearToDateView({
  packageDetailsData,
  zoeShipmentTrackingData,
  loading,
  onNavigateToPackageDetails,
  onNavigateToShipmentTracking,
  onNavigateToShipmentStatus
}) {
  if (!packageDetailsData || !zoeShipmentTrackingData) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="200px"
      >
        <Typography variant="h6" color="textSecondary">
          {loading ? 'Loading dashboard data...' : 'No data available'}
        </Typography>
      </Box>
    );
  }

  return (
    <Grid container spacing={3}>
      {/* Package Details Year to Date */}
      <Grid item xs={12}>
        <Paper sx={{ p: 3 }}>
          <SectionHeader
            title="Package Details - Year to Date"
            icon={<Inventory />}
          />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <CompactStatCard
                title="Total Packages"
                value={packageDetailsData.ytd.total}
                subtitle="All packages processed this year"
                icon={<Inventory />}
                color="primary"
                onNavigate={onNavigateToPackageDetails}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CompactStatCard
                title="Incoming Packages"
                value={packageDetailsData.ytd.incoming}
                subtitle="Packages received this year"
                icon={<TrendingUp />}
                color="success"
                onNavigate={onNavigateToPackageDetails}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CompactStatCard
                title="Outgoing Packages"
                value={packageDetailsData.ytd.outgoing}
                subtitle="Packages shipped this year"
                icon={<LocalShipping />}
                color="warning"
                onNavigate={onNavigateToPackageDetails}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CompactStatCard
                title="Unclassified Packages"
                value={packageDetailsData.ytd.unclassified}
                subtitle="Packages without proper classification"
                icon={<QuestionMark />}
                color="error"
                onNavigate={onNavigateToPackageDetails}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>

      {/* Zoe Shipment Tracking Year to Date */}
      <Grid item xs={12}>
        <Paper sx={{ p: 3 }}>
          <SectionHeader
            title="Zoe Shipment Tracking - Year to Date"
            icon={<LocalShipping />}
          />
          <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12} sm={6} md={3}>
              <CompactStatCard
                title="Total Shipments"
                value={zoeShipmentTrackingData.ytd.total}
                subtitle="All shipments tracked this year"
                icon={<LocalShipping />}
                color="primary"
                onNavigate={onNavigateToShipmentTracking}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CompactStatCard
                title="Delivered"
                value={zoeShipmentTrackingData.ytd.delivered}
                subtitle="Successfully delivered this year"
                icon={<TrendingUp />}
                color="success"
                onNavigate={() => onNavigateToShipmentStatus('Delivered')}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CompactStatCard
                title="In Transit"
                value={zoeShipmentTrackingData.ytd.inTransit}
                subtitle="Currently shipping"
                icon={<LocalShipping />}
                color="info"
                onNavigate={() => onNavigateToShipmentStatus('In Transit')}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CompactStatCard
                title="Checked In"
                value={zoeShipmentTrackingData.ytd.checkedIn}
                subtitle="Checked into facility"
                icon={<Inventory />}
                color="primary"
                onNavigate={() => onNavigateToShipmentStatus('Checked In')}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <CompactStatCard
                title="Checked Out"
                value={zoeShipmentTrackingData.ytd.checkedOut}
                subtitle="Checked out for delivery"
                icon={<LocalShipping />}
                color="secondary"
                onNavigate={() => onNavigateToShipmentStatus('Checked Out')}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <CompactStatCard
                title="Pending"
                value={zoeShipmentTrackingData.ytd.pending}
                subtitle="Awaiting shipment"
                icon={<CalendarToday />}
                color="warning"
                onNavigate={() => onNavigateToShipmentStatus('Pending')}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <CompactStatCard
                title="Unclassified"
                value={zoeShipmentTrackingData.ytd.unclassified}
                subtitle="Unknown status shipments"
                icon={<QuestionMark />}
                color="error"
                onNavigate={() => onNavigateToShipmentStatus('Unclassified')}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
}
